/* eslint-disable no-unused-vars */
import React, { useState,  useEffect, useMemo } from "react";
import {
  Button,
  TextField,
  Typography,
  MenuItem,
  Grid,
  Select,
  InputLabel,
  Stack,
  Modal,
} from "@mui/material";
import data from "./dropDown";
import { API } from "../pages/backend";
import { useDispatch, useSelector } from "react-redux";
import { setTransactionDetails } from "../store/reducers/transactionDetails";
import InputField from "./forms/input/TextInput/InputField";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { examPrices } from "../partials/examboardprices/examprices";
import FormButton from "./ui/button/FormButton";
import axios from "axios";
import { closeModal } from "../store/reducers/modal";
import Spinner from "./ui/Spinner";
import InvoiceButtonWithConfirmation from "./InvoiceButtonWithConfirmation";

const BulkModel = ({
  dat,
  examName,
  examType = "MODEL SCREENING EXAMINATION",
  lateRegistrationType = "Model/Screening College Late Registration",
  payerID,
}) => {
  // modal for construction
  const [open, setOpen] = useState(false);
  // const handleOpen = () => {
  //   setOpen(true);
  // };

  // // Function to handle closing the modal
  // const handleClose = () => {
  //   setOpen(false);
  // };

  // // Optional: Function to navigate away after closing modal
  // const handleConfirm = () => {
  //   setOpen(false);
  //   navigate("/requisition/model/maintenance"); // Navigate if needed
  // };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleConfirm = () => {
    setOpen(false);
    handleInvoiceClick(); // Call your actual handler
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const { Lga } = data;
  const token = useSelector((state) => state.user.data.token);
  // const details = useSelector((state) => state.transactionDetails);
  const user = useSelector((state) => state.user.data.details);

  const [modelCollegeBulkData, setModelCollegeBulkData] = useState([]);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  // const modelPrice = examPrices.modelCollegeExamFeePerCandidiate;
  // const priceInt = modelPrice.replace(/\D/g, "");

  const [candidates, setCandidates] = useState([
    { lastName: "", middleName: "", firstName: "", lga: "" },
  ]);

  console.log(candidates.length);
  const candidateInfo = candidates.map((candidate, index) => ({
    surname: candidate.lastName,
    middleName: candidate.middleName,
    firstName: candidate.firstName,
    //  lgaIdNumber: candidate.lga,
    locationIdOrExamId: candidate.lga,
  }));

  // console.log(candidateInfo)

  const addCandidate = () => {
    const newCandidate = {
      lastName: "",
      middleName: "",
      firstName: "",
      lga: "",
    };
    setCandidates([...candidates, newCandidate]);
  };

  const removeCandidate = (index) => {
    const updateCandidate = candidates.filter((_, idx) => idx !== index);
    setCandidates(updateCandidate);
  };

  const handleCandidateChange = (index, field, value) => {
    const updatedCandidates = [...candidates];
    updatedCandidates[index] = { ...updatedCandidates[index], [field]: value };
    setCandidates(updatedCandidates);
  };

  const priceInt = examPrices.modelCollegeExamFeePerCandidiate.replace(
    /\D/g,
    ""
  );
  const totalFee = priceInt * candidates.length;

  // const totalAmount = parseInt(charge) + parseInt(totalFee);

  const charge = useMemo(() => {
    let ch = 0.01 * totalFee;
    if (ch > 3000) return 3000;
    return ch;
  }, [totalFee]);

  const totalAmount = parseInt(charge) + parseInt(totalFee);

  // console.log(user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
    } catch (error) {}
  };

  const getModelCollegeBulkBillable = async () => {
    const examBillable_url = `${API}/cbs/college_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setModelCollegeBulkData(res?.data?.data);
      // console.log(modelCollegeBulkData);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
      // Start the timeout
      let timeoutId = setTimeout(() => {
        setShowTimeoutModal(true);
      }, 120000); // 2 minutes in milliseconds
    const body = {
      payer_id: payerID,
      customer_name: `${user.firstName} ${user.lastName}`,
      selected_quantities: [parseInt(candidates.length)],
      selected_items: [modelCollegeBulkData?.[1]?.PRODUCTS_ID],
      selected_tariffs: [10000],
      assessmentCode: "01",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
                // If the request completes successfully, clear the timeout
    clearTimeout(timeoutId);
      // console.log(res)
      if (res?.status === 200) {
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.bill_number);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          // payerId: details?.payerId,
          payerId: payerID,
          amountGenerated: totalFee,
          customerName: `${user.lastName} ${user.firstName}`,
          quantity: candidates.length,
          assessmentCode: "01",
          payerInfos: candidateInfo,
        };

        const bill = saveGeneratedBill(billdata);
        // console.log(bill);

        // console.log(bill);
        // transactionDetails.billNumber = res?.data?.data?.responseData;
        // console.log(transactionDetails);
        const modelUserTransactionDetails = {
          payerName: `${user.lastName} ${user.firstName}`,
          productQuantity: parseInt(candidates.length),
          price: totalFee,
          // schoolName: "",
          unitPrice: parseInt(priceInt),
          examType,
          paymentExamType: examType,
          fullDesc: "Screening Test Model College[NGN]",
          billNumber: res?.data?.data?.bill_number,
          payerId: user?.payerId,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        // console.log(modelUserTransactionDetails);

        // console.log("i got here");
        dispatch(setTransactionDetails(modelUserTransactionDetails));
        // dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));
        navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
  clearTimeout(timeoutId);

  if (axios.isAxiosError(error)) {
    const backendMessage = error.response?.data?.message || "Something went wrong";
    toast.error(backendMessage);
  } else {
    toast.error("An unexpected error occurred");
  }

  console.error(error);
}
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      // e.preventDefault();
      const isEmpty = candidates.some((candidate) => {
        // Regular expression to match any number or special character
        const regex = /[0-9~`!@#$%^&*()_+=\-[\]\\';,/{}|\\":<>?]/;
        // Regular expression to match alphabetical letters only
        const alphaRegex = /^[A-Za-z]+(-[A-Za-z]+)*$/;


        if (
          candidate.firstName.trim().length < 3 ||
          candidate.lastName.trim().length < 3
        ) {
          throw new Error(
            "First Name and Last Name are required with a minimum of 3 characters."
          );
        }

        // if (!alphaRegex.test(candidate.firstName)) {
        //   throw new Error(
        //     "First name should contain only alphabetical letters."
        //   );
        // }

        // if (!alphaRegex.test(candidate.lastName)) {
        //   throw new Error(
        //     "Last name should contain only alphabetical letters."
        //   );
        // }

        if (!candidate.lga) {
          throw new Error("Local Government Area is required.");
        }

        // if (regex.test(candidate.firstName) || regex.test(candidate.lastName)) {
        //   throw new Error(
        //     "Name fields should not contain numbers or special character."
        //   );
        // }

        return false;
      });

      if (isEmpty) {
        // No need to throw an error here since all validations are handled within the `isEmpty` check
      }

      await generateBillNo();
      // console.log(transactionDetails)
      // console.log(examName)
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    } finally {
      setInvoiceLoading(false);
    }
  };

  useEffect(() => {
    getModelCollegeBulkBillable();
  }, []);

  return (
    <div
      style={{
        padding: "16px",
        maxHeight: "calc(100vh - 160px)",
        overflowY: "auto",
      }}
    >
              {showTimeoutModal && (
        <Modal show={showTimeoutModal} onHide={() => setShowTimeoutModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Server Delay</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The bill generation is taking longer than expected. This may be due to a delay from our third-party server. Please wait a moment and try again later.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowTimeoutModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {candidates.map((candidate, index) => (
        // return (
        <div
          key={index}
          style={{
            // display: "flex",
            // alignItems: "center",
            // gap: "1.5rem",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "20px",
              // padding: "1rem",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
              <InputField
                  name="lastName"
                  label="SurName"
                  type="text"
                  placeholder="Enter Last Name"
                  value={candidate.lastName}
                  onChange={(e) =>
                    handleCandidateChange(index, "lastName", e.target.value.trim())
                  }
                  style={{ width: "100%" }}
                />

              </Grid>
              <Grid item xs={6} md={6}>
              <InputField
                  name="FirstName"
                  label="First Name"
                  value={candidate.firstName}
                  placeholder=" Enter First Name"
                  type="text"
                  onChange={(e) =>
                    handleCandidateChange(index, "firstName", e.target.value.trim())
                  }
                  style={{ width: "100%" }}
                />
               
              </Grid>
            </Grid>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "32px" }}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
              <InputField
                  name="MiddleName"
                  label="Other Name"
                  value={candidate.middleName}
                  placeholder=" Enter Middle Name"
                  type="text"
                  onChange={(e) =>
                    handleCandidateChange(index, "middleName", e.target.value.trim())
                  }
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#9b9494",
                    fontSize: "1rem",
                    fontWeight: "bolder",
                    paddingTop: "16px",
                  }}
                >
                  L.G.A
                </Typography>
                <TextField
                  label="Select L.G.A"
                  select
                  value={candidate.lga}
                  onChange={(e) =>
                    handleCandidateChange(index, "lga", e.target.value)
                  }
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {Lga.map((lgaItem) => (
                    <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                      {lgaItem.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            {/* <Grid item xs={2} style={{ paddingBottom: "1rem" }}>
              <FormButton
                width="small"
                label="Add Candidate"
                onClick={addCandidate}
              />
            </Grid> */}
          </div>
          {/* visibility: candidates.length > 1 ? 'visible' : 'hidden'  */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // gap: "50%",
              visibility: candidates.length > 1 ? "visible" : "hidden",
            }}
          >
            <FormButton
              width="medium"
              label="Remove"
              onClick={() => removeCandidate(index)}
            />
          </div>
        </div>
      ))}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField
              name="NoOfCandidates"
              label="No of Candidates"
              type="text"
              placeholder="Enter Last Name"
              value={candidates.length}
              // onChange={(e) =>
              //   handleCandidateChange(index, "lastName", e.target.value)
              // }
              style={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={6}>
            <InputField
              name="TotalPrice"
              label="Total Price"
              value={priceInt * candidates.length}
              // placeholder=" Enter Middle Name"
              type="text"
              // onChange={(e) =>
              //   handleCandidateChange(index, "middleName", e.target.value)
              // }
              style={{ width: "100%" }}
            />
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          padding: "16px",
        }}
      >
        {/* <Button
          onClick={addTestDetail}
          color="secondary"
          variant="contained"
          sx={{
            textTransform: "inherit",
            fontWeight: "bold",
            mr: "5px",
            mt: "2rem",
          }}
        >
          Add
        </Button> */}
        {/* <Stack > */}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
          container
        >
          <Grid item xs={2}>
            <FormButton
              width="medium"
              label="Add Candidate"
              onClick={addCandidate}
            />
          </Grid>
          <Grid item xs={2}>
        <InvoiceButtonWithConfirmation
  invoiceLoading={invoiceLoading}
  handleInvoiceClick={handleInvoiceClick}
/>


          </Grid>
        </div>
      </div>
    </div>
  );
};

export default BulkModel;
